import { Link } from 'react-router-dom';
import { PageHeader } from '@/components/common/PageHeader';
import { UNAVAILABLE_FEATURES, type UnavailableFeatureKey } from '@/config/features';
import { SparklesIcon } from '@heroicons/react/24/outline';

/**
 * Full-page state for a capability whose backend is not deployed yet. Makes
 * no API calls and offers no actions that could fail.
 */
export function FeatureUnavailable({ feature }: { feature: UnavailableFeatureKey }) {
  const f = UNAVAILABLE_FEATURES[feature];
  return (
    <div>
      <PageHeader title={f.title} description={f.summary} />
      <section className="flex flex-col items-center rounded-xl border border-border bg-surface px-6 py-16 text-center">
        <span className="grid h-14 w-14 place-items-center rounded-2xl bg-brand/10 text-brand">
          <SparklesIcon className="h-7 w-7" aria-hidden="true" />
        </span>
        <span className="mt-4 rounded-full border border-border px-3 py-1 text-xs font-medium text-fg-muted">
          Not enabled yet
        </span>
        <h2 className="mt-3 text-lg font-semibold text-fg">{f.title} is not enabled for this platform yet</h2>
        <p className="mt-2 max-w-md text-sm text-fg-muted">
          This feature will appear here once it is switched on. No data is shown in the meantime, and nothing on
          this page affects your mail service.
        </p>
        <Link to="/" className="mt-6 text-sm font-medium text-brand hover:underline">Back to Overview</Link>
      </section>
    </div>
  );
}
